import http from './axiosConfig' //引入基础配置
import { newBaseUrl as baseUrl } from "./api";
let getData = {}
//手机验证码---周
getData.yzm = (data,mobile)=>{ 
    return http.get(baseUrl + '/verification/sms_codes/' +mobile + '/',{ params:data })
  }
  //测试接口数据
  getData.xxce = (data)=>{ 
    return http.get(baseUrl + '/one/test/',{ params:data })
  }
  //手机注册
  getData.reg = (data)=>{ 
    return http.post(baseUrl+"/one/register/",data)
  }
  //小程序根据手机验证码登录----李
  getData.wechatloginv2= (data)=>{ 
    return http.post(baseUrl+"/one/wechatloginv2/",data)
  }
  //小程序发送手机验证码---李
  getData.WXyzm= (data,mobile)=>{ 
    return http.get(baseUrl + '/verification/sms_codes1/' +mobile + '/',{ params:data })
  }
  //创建项目，需公司管理员操作------------------
  getData.createproject = (data)=>{ 
    return http.post(baseUrl+"/one/createproject/",data)
  }
  //查看项目列表
  getData.projectlist = (data)=>{
    return http.post(baseUrl+"/one/projectlist/",data)
  }
  //关联用户
  getData.signproject = (data)=>{ 
    return http.post(baseUrl+"/one/signproject/",data)
  }
  //关联用户列表
  getData.responserlist = (data)=>{ 
    return http.post(baseUrl+"/one/responserlist/",data)
  }
  //查看项目信息
  getData.viewproject = (data)=>{ 
    return http.post(baseUrl+"/one/viewproject/",data)
  }
  //修改项目信息
  getData.editproject = (data)=>{
    return http.post(baseUrl+"/one/editproject/",data)
  }
  //修改项目信息
  getData.deactivateproject = (data)=>{ 
    return http.post(baseUrl+"/one/deactivateproject/",data)
  }
  //取消用户与项目关联
  getData.unsignproject = (data)=>{ 
    return http.post(baseUrl+"/one/unsignproject/",data)
  }
  //更改密码
  getData.Changepassword = (data)=>{ 
    return http.post(baseUrl+"/one/changepassword/",data)
  }
  //登录用户名和密码
  getData.userName = (data)=>{ 
    return http.post(baseUrl+"/one/login/",data)
  }
  //修改用户
  getData.UserInformation = (data)=>{ 
    let config = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return http.post(baseUrl+"/one/editmyprofile/",data,config)
  }
  //获取用户信息
  getData.getUserInformation = (data)=>{ 
    return http.get(baseUrl + '/one/editmyprofile/',{ params:data })
  }
  //加入公司
  getData.joincompany= (data)=>{ 
    return http.post(baseUrl + '/one/joincompany/',data)
  }
  //查看新员工申请表
  getData.unactivestafflist= (data)=>{ 
    return http.post(baseUrl + '/one/unactivestafflist/',data)
  }
  //查看公司员工
  getData.companystaff= (data)=>{ 
    return http.post(baseUrl + '/one/companystaff/',data)
  }
  //同意添加新员工加入申请
  getData.enrollstaff= (data)=>{ 
    return http.post(baseUrl + '/one/enrollstaff/',data)
  }
  //停用员工，需公司管理员身份
  getData.deactivatestaff= (data)=>{ 
    return http.post(baseUrl + '/one/deactivatestaff/',data)
  }
  
  //创建公司
  getData.createcompany= (data)=>{ 
    return http.post(baseUrl + '/one/createcompany/',data)
  }
  //搜索所有激活状态公司
  getData.companylist= (data)=>{ 
    return http.get(baseUrl + '/one/companylist/',{ params:data })
  }
  //搜索所有公司
  getData.allcompanylist= (data)=>{ 
    return http.get(baseUrl + '/one/allcompanylist/',{ params:data })
  }
  //按照名称搜索公司-加入公司-------周
  getData.selectcompany= (data)=>{ 
    return http.get(baseUrl + '/one/selectcompany/',{ params:data })
  }
  //搜索所有未激活状态公司
  getData.unactivatedcompanylist= (data)=>{ 
    return http.post(baseUrl + '/one/unactivatedcompanylist/',data)
  }
  //通过新公司申请审批,需要后台人员身份
  getData.activecompany= (data)=>{ 
    return http.post(baseUrl + '/one/activecompany/',data)
  }
  //点击查看其他公司详情--后台罗列
  getData.companyprofile= (data)=>{ 
    return http.get(baseUrl + '/one/companyprofile/',{ params:data })
  }
  //查看自己所属的公司-
  getData.editcompany= (data)=>{ 
    return http.get(baseUrl + '/one/editcompany/',{ params:data })
  }
  //编辑自己所属的公司-
  getData.Peditcompany= (data)=>{ 
    return http.post(baseUrl + '/one/editcompany/',data)
  }
  //停用公司，需要公司管理员身份或后台人员身份
  getData.deactivecompany= (data)=>{ 
    return http.post(baseUrl + '/one/deactivecompany/',data)
  }
  //用户创建投诉记录
  getData.createusercomplain= (data)=>{ 
    return http.post(baseUrl + '/one/createusercomplain/',data)
  }
  //添加工单,需后台工作人员身份
  getData.addworksheet= (data)=>{ 
    return http.post(baseUrl + '/one/addworksheet/',data)
  }
  //查看我的工单列表,需后台工作人员身份
  getData.viewmyworksheets= (data)=>{ 
    return http.get(baseUrl + '/one/viewmyworksheets/',{ params:data })
  }
  //查看工单详情
  getData.editworksheet= (data)=>{ 
    return http.get(baseUrl + '/one/editworksheet/',{ params:data })
  }
  //修改工单详情
  getData.Peditworksheet= (data)=>{ 
    return http.post(baseUrl + '/one/editworksheet/',data)
  }
  //搜索工单
  getData.searchworksheets= (data)=>{ 
    return http.get(baseUrl + '/one/searchworksheets/',{ params:data })
  }
  //查看我的工单列表
  getData.viewworksheets= (data)=>{ 
    return http.post(baseUrl + '/one/viewworksheets/',data)
  }
  //运维创建设备维修记录
  getData.addmaintainrecord= (data)=>{ 
    return http.post(baseUrl + '/one/addmaintainrecord/',data)
  }
  //查看设备所有维修记录 
  getData.maintainrecordlist= (data)=>{ 
    return http.get(baseUrl + '/one/maintainrecordlist/',{ params:data })
  }
  //删除设备维修记录
  getData.deletemaintainrecord= (data)=>{ 
    return http.post(baseUrl + '/one/deletemaintainrecord/',data)
  }
  //公司管理员创建员工----周
  getData.managercreatestaff= (data)=>{ 
    return http.post(baseUrl + '/one/managercreatestaff/',data)
  }
  //忘记密码----周
  getData.forgetpassword= (data)=>{ 
    return http.post(baseUrl + '/one/forgetpassword/',data)
  }
  //修改手机号----周
  getData.modifyphonenumber= (data)=>{ 
    return http.post(baseUrl + '/one/modifyphonenumber/',data)
  }
  //添加知识库/行业资讯，需后台人员操作，类型k_type需限制为：知识库或行业资讯
  getData.addknowledge= (data)=>{ 
    return http.post(baseUrl + '/one/addknowledge/',data)
  }
  //查询知识库列表
  getData.knowledgelist= (data)=>{ 
    return http.get(baseUrl + '/one/knowledgelist/',{ params:data })
  }
  //查询知识库列表 --前台
  getData.knowledgelistfront= (data)=>{ 
    return http.get(baseUrl + '/one/knowledgelistfront/',{ params:data })
  }
  //查看单个的知识库详情
  getData.editknowledge= (data)=>{ 
    return http.get(baseUrl + '/one/editknowledge/',{ params:data })
  }
  //查询知识库与解决方案, GET功能需传值知识库/行业资讯id： k_id
  getData.viewknowledge= (data)=>{ 
    return http.get(baseUrl + '/one/viewknowledge/',{ params:data })
  }
  //添加知识库/行业资讯***解决方案***，需后台人员操作
  getData.addsolution= (data)=>{ 
    return http.post(baseUrl + '/one/addsolution/',data)
  }
  //查看单知识的***解决方案**参数：*知识库id s_k_id
  getData.viewsolution= (data)=>{ 
    return http.get(baseUrl + '/one/viewsolution/',{ params:data })
  }
  //修改单知识的***解决方案**参数：*知识库id s_k_id
  getData.Pviewsolution= (data)=>{ 
    return http.post(baseUrl + '/one/viewsolution/',data)
  }
  //修改单知识的***解决方案**参数：*知识库id s_k_id
  getData.deleteknowledge= (data)=>{ 
    return http.post(baseUrl + '/one/deleteknowledge/',data)
  }
  //查看行业资讯列表  --前台
  getData.knowledgelistv2front= (data)=>{ 
    return http.get(baseUrl + '/one/knowledgelistv2front/',{params:data})
  }
  //查看行业资讯列表--五条行业资讯
  getData.knowledgelistv5= (data)=>{ 
    return http.get(baseUrl + '/one/knowledgelistv5/',{params:data})
  }
  //查看行业资讯列表--五条行业资讯
  getData.knowledgelistv4= (data)=>{ 
    return http.get(baseUrl + '/one/knowledgelistv4/',{params:data})
  }
  //查看行业资讯列表
  getData.knowledgelistv3= (data)=>{ 
    return http.get(baseUrl + '/one/knowledgelistv3/',{params:data})
  }
  //查询企业动态列表
  getData.enterpriselist= (data)=>{ 
    return http.get(baseUrl + '/one/enterpriselist/',{params:data})
  }
  //运维添加企业动态
  getData.addenterprise= (data)=>{ 
    return http.post(baseUrl + '/one/addenterprise/',data)
  }
  //用户控制台-获取我的设备列表
  getData.persondevicelist= (data)=>{ 
    return http.post(baseUrl + '/one/persondevicelist/',data)
  }
  //用户控制台-我的设备列表中数据按钮功能测试--过去24小时
  getData.testtttt= (data)=>{ 
    return http.get(baseUrl + '/one/testtttt/',{params:data})
  }
  //用户控制台-我的设备列表中数据按钮功能测试--过去一星期
  getData.oneweek= (data)=>{ 
    return http.get(baseUrl + '/one/oneweek/',{params:data})
  }
  //用户控制台-我的设备列表中数据按钮功能测试--过去一个月
  getData.onemonth= (data)=>{ 
    return http.get(baseUrl + '/one/onemonth/',{params:data})
  }
  //查询单个企业动态
  getData.viewenterprise= (data)=>{ 
    return http.get(baseUrl + '/one/viewenterprise/',{params:data})
  }
  //修改单个企业动态
  getData.Pviewenterprise = (data)=>{ 
    return http.post(baseUrl+"/one/viewenterprise/",data)
  }
  //删除
  getData.deleteenterprise = (data)=>{ 
    return http.post(baseUrl+"/one/deleteenterprise/",data)
  }
  //后台---登录用户名和密码
  getData.blogin = (data)=>{ 
    return http.post(baseUrl+"/one/blogin/",data)
  }
  //后台---登录用户名和密码
  getData.managercreatestaffv2 = (data)=>{ 
    return http.post(baseUrl+"/one/managercreatestaffv2/",data)
  }
  //展示后台全部员工，需要admin操作
  getData.employeelist = (data)=>{ 
    return http.post(baseUrl+"/one/employeelist",data)
  }
  //后台修改员工
  getData.editstaff = (data)=>{ 
    return http.post(baseUrl+"/one/editstaff/",data)
  }
  //后台停用员工，需公司管理员身份
  getData.deactivatestaffv2 = (data)=>{ 
    return http.post(baseUrl+"/one/deactivatestaffv2/",data)
  }
  
  //添加采集设备信息，需公司管理员或运维人员操作
  getData.applycollectdevice = (data)=>{ 
    return http.post(baseUrl+"/one/applycollectdevice/",data)
  }
  //添加采集设备信息，需公司管理员或运维人员操作
  getData.getdevice = (data)=>{ 
    return http.get(baseUrl+"/one/getdevice/",{ params:data })
  }
  //导入采集设备参数，需公司管理员或运维人员操作
  getData.gettags = (data)=>{ 
    return http.get(baseUrl+"/one/gettags/",{ params:data })
  }
  //查看采集设备列表信息editcollectdevice
  getData.collectdevicelist = (data)=>{ 
    return http.get(baseUrl+"/one/collectdevicelist/",{ params:data })
  }
  //查看单个采集设备信息editcollectdevice
  getData.getCollectdevice = (data)=>{ 
    return http.get(baseUrl+"/one/editcollectdevice/",{ params:data })
  }
  //修改单个采集设备信息editcollectdevice
  getData.editcollectdevice = (data)=>{ 
    return http.post(baseUrl+"/one/editcollectdevice/",data)
  }
  //删除采集设备信息
  getData.delcollectdevice = (data)=>{ 
    return http.post(baseUrl+"/one/delcollectdevice/",data)
  }
  //添加机械设备
  // getData.applydevice = (data)=>{ 
  //   return http.post(baseUrl+"/one/applydevice/",data)
  // }
  
  //后台操作---采集设备后台给url
  getData.collectdevicelistv2 = (data)=>{ 
    return http.get(baseUrl+"/one/collectdevicelistv2/",{ params:data })
  }
  //采集设备后台给url
  getData.collectdeviceattlistv3 = (data)=>{ 
    return http.post(baseUrl+"/one/collectdeviceattlistv3/",data)
  }
  //机械设备列表
  // getData.devicelist = (data)=>{ 
  //   return http.post(baseUrl+"/one/devicelist/",data)
  // }
  //机械设备参数列表
  getData.devicegrouplist = (data)=>{ 
    return http.post(baseUrl+"/one/devicegrouplist/",data)
  }
  //机械设备详细信息
  // getData.viewdevice = (data)=>{ 
  //   return http.get(baseUrl+"/one/viewdevice/",{ params:data })
  // }
  //机械设备添加附加属性
  getData.addlydeviceatt = (data)=>{ 
    return http.post(baseUrl+"/one/addlydeviceatt/",data)
  }
  //机械设备删除附加属性
  getData.deldeviceatt = (data)=>{ 
    return http.post(baseUrl+"/one/deldeviceatt/",data)
  }
  //机械设备新增参数组
  getData.adddevicegroup = (data)=>{ 
    return http.post(baseUrl+"/one/adddevicegroup/",data)
  }
  //机械设备删除参数组
  getData.deldevicegroup = (data)=>{ 
    return http.post(baseUrl+"/one/deldevicegroup/",data)
  }
  //机械设备新增参数 -- 查看参数列表
  getData.viewdata = (data)=>{ 
    return http.post(baseUrl+"/one/viewdata/",data)
  }
  //机械设备新增参数 -- 添加参数
  getData.deviceadddata = (data)=>{ 
    return http.post(baseUrl+"/one/deviceadddata/",data)
  }
  //创建机械设备维修日志
  getData.addmaintainrecord = (data)=>{ 
    return http.post(baseUrl+"/one/addmaintainrecord/",data)
  }
  //查询机械设备维修日志
  getData.searchrecords = (data)=>{ 
    return http.get(baseUrl+"/one/searchrecords/",{ params:data })
  }
  //查看公司所有机械设备维修记录
  getData.companymaintainrecordlist = (data)=>{ 
    return http.post(baseUrl+"/one/companymaintainrecordlist/",data)
  }
  //查看机械设备维修日志详情
  getData.viewmaintainrecord = (data)=>{ 
    return http.post(baseUrl+"/one/viewmaintainrecord/",data)
  }
  //删除机械设备维修日志
  getData.deletemaintainrecord = (data)=>{ 
    return http.post(baseUrl+"/one/deletemaintainrecord/",data)
  }
  //删除机械设备
  getData.deletedevice = (data)=>{ 
    return http.post(baseUrl+"/one/deletedevice/",data)
  }
  //机械设备后台给url
  getData.devicelistv2 = (data)=>{ 
    return http.get(baseUrl+"/one/devicelistv2/",{ params:data })
  }
  //设备-组态
  getData.dashboardv2 = (data)=>{ 
    return http.get(baseUrl+"/one/dashboardv2/",{ params:data })
  }
  //采集设备
  getData.nodeIds= (rurl,token)=>{ 
    return http.get(rurl,{
      headers: {
        Authorization:'Bearer '+sessionStorage.getItem('Token')
      }
    })
  }
  //机械设备
  getData.Mechanics= (rurl)=>{ 
    return http.get(rurl,{
      headers: {
        Authorization:'Bearer '+sessionStorage.getItem('Token')
      }
    })
  }
  //登录
  getData.Ldenglu = ()=>{ 
    return http.post("https://portal-apm-user1-eks004.hz.wise-paas.com.cn/api-apm/auth/login",{
      "userName": "442307942@qq.com",
      "password": "WWgyMDIwMTAyN0BA"
    })
  }
  export default getData


// WEBPACK FOOTER //
// ./src/common/PhaseI.js